import { render, staticRenderFns } from "./Act004FormScopeHotspot.vue?vue&type=template&id=c1d0b258&scoped=true"
import script from "./Act004FormScopeHotspot.vue?vue&type=script&lang=js"
export * from "./Act004FormScopeHotspot.vue?vue&type=script&lang=js"
import style0 from "./Act004FormScopeHotspot.vue?vue&type=style&index=0&id=c1d0b258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d0b258",
  null
  
)

export default component.exports